import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-662f5d18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-h5 font-weight-black ps-2" }
const _hoisted_2 = { class: "font-weight-black" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "font-weight-black" }
const _hoisted_5 = { class: "mt-2 mb-6" }
const _hoisted_6 = { class: "font-weight-black" }
const _hoisted_7 = { class: "font-weight-black" }
const _hoisted_8 = { class: "font-weight-black" }
const _hoisted_9 = { class: "mt-2 mb-6 text-start" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "font-weight-black" }
const _hoisted_12 = { class: "mt-2 mb-6 text-start" }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "font-weight-black" }
const _hoisted_15 = { class: "font-weight-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    onSubmit: _withModifiers(_ctx.submitEditedDevice, ["prevent"]),
    ref: "form"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { rounded: "lg" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('i18n.editDeviceModalTitle')), 1),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                variant: "text",
                onClick: _ctx.closeModal,
                size: "x-large"
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "overflow-y-auto" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('i18n.name')), 1),
              _createVNode(_component_v_text_field, {
                density: "compact",
                modelValue: _ctx.updatedDevice.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.updatedDevice.name) = $event)),
                variant: "outlined",
                rules: _ctx.deviceNameRules,
                clearable: ""
              }, null, 8, ["modelValue", "rules"]),
              (_ctx.updatedDevice.type_id === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('i18n.uuidLabel')), 1),
                    _createVNode(_component_v_text_field, {
                      density: "compact",
                      modelValue: _ctx.updatedDevice.uuid,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.updatedDevice.uuid) = $event)),
                      variant: "outlined",
                      rules: _ctx.deviceUuidRules,
                      "hide-details": "auto",
                      clearable: ""
                    }, null, 8, ["modelValue", "rules"]),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('i18n.uuidHint')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('i18n.description')), 1),
              _createVNode(_component_v_text_field, {
                density: "compact",
                modelValue: _ctx.updatedDevice.description,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.updatedDevice.description) = $event)),
                variant: "outlined",
                rules: _ctx.deviceDescriptionRules,
                clearable: ""
              }, null, 8, ["modelValue", "rules"]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('i18n.location')), 1),
              _createVNode(_component_v_text_field, {
                density: "compact",
                modelValue: _ctx.updatedDevice.location,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.updatedDevice.location) = $event)),
                variant: "outlined",
                rules: _ctx.deviceLocationRules,
                clearable: ""
              }, null, 8, ["modelValue", "rules"]),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('i18n.deviceTypeLabel')), 1),
              _createVNode(_component_v_select, {
                value: _ctx.deviceTypeName(_ctx.device.type_id),
                disabled: "",
                variant: "outlined",
                density: "compact",
                "hide-details": true,
                required: "",
                "no-data-text": _ctx.$t('i18n.noDeviceTypes')
              }, null, 8, ["value", "no-data-text"]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('i18n.deviceTypeHint')), 1),
              (_ctx.updatedDevice.type_id === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('i18n.completionRedirectUrl')), 1),
                    _createVNode(_component_v_text_field, {
                      density: "compact",
                      modelValue: _ctx.updatedDevice.completion_redirect_url,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.updatedDevice.completion_redirect_url) = $event)),
                      "hide-details": "auto",
                      variant: "outlined",
                      rules: _ctx.urlRules,
                      clearable: ""
                    }, null, 8, ["modelValue", "rules"]),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('i18n.completionRedirectUrlHint')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.updatedDevice.type_id === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('i18n.ipAddress')), 1),
                    _createVNode(_component_v_text_field, {
                      density: "compact",
                      modelValue: _ctx.updatedDevice.ip_address,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.updatedDevice.ip_address) = $event)),
                      variant: "outlined",
                      rules: _ctx.deviceIpRules,
                      clearable: ""
                    }, null, 8, ["modelValue", "rules"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('i18n.associateFormLabel')), 1),
              _createVNode(_component_v_select, {
                modelValue: _ctx.updatedDevice.form_id,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.updatedDevice.form_id) = $event)),
                items: _ctx.simplifiedFormList,
                "item-value": "id",
                "item-title": "name",
                variant: "outlined",
                density: "compact",
                chips: "",
                "closable-chips": "",
                "no-data-text": _ctx.$t('i18n.noForms')
              }, null, 8, ["modelValue", "items", "no-data-text"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: "gorate-btn-bg-outlined",
                variant: "outlined",
                rounded: "xl",
                text: _ctx.$t('i18n.closeBtnText'),
                onClick: _ctx.closeModal
              }, null, 8, ["text", "onClick"]),
              _createVNode(_component_v_btn, {
                class: "gorate-btn-bg",
                rounded: "xl",
                text: _ctx.$t('i18n.saveBtnText'),
                type: "submit"
              }, null, 8, ["text"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}